var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.sectionClasses},_vm._l((_vm.rawList),function(data){return _c('HoldingItem',_vm._b({key:data.id},'HoldingItem',Object.assign({}, _vm.cardProps, {data: data}),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }